import { GridList } from '@tribeplatform/react-ui-kit/Layout'

import type { StaticField, View } from '../../Views/types.js'
import type { QuickLinksSource } from '../types.js'
import { getColumns } from '../utils/index.js'
import { QuickLinksGalleryItem } from './QuickLinksGalleryItem.js'

interface Props {
  sources: QuickLinksSource[]
  fields: StaticField[]
  gallerySize: View['gallerySize']
  activeFieldId?: string
  preview: boolean
}
export const QuickLinksGallery = ({
  sources,
  fields,
  gallerySize = 'medium',
  activeFieldId,
  preview,
}: Props) => {
  const columns = getColumns(gallerySize)

  return (
    <GridList columns={columns}>
      {sources.map(source => (
        <QuickLinksGalleryItem
          key={source.id}
          source={source}
          fields={fields.filter(
            field =>
              field.enabled &&
              !(field.styles && field.styles.indexOf('gallery') === -1),
          )}
          activeFieldId={activeFieldId}
          preview={preview}
        />
      ))}
    </GridList>
  )
}
